let $ = require('jquery');
let SCI = require('sci');

SCI.boot().then(() => {
    $('[type=checkbox]').uniform();
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/pages/login.js